import script from "./TheHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHelp.vue?vue&type=script&setup=true&lang=ts"

import "./TheHelp.vue?vue&type=style&index=0&id=5c67d07c&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c67d07c"]])

export default __exports__